// google-maps.service.ts
// 
// This service loads Google Maps APIs for address autocomplete functionality.
// 
// Required Google Cloud APIs:
// 1. Places API - for address autocomplete suggestions
// 2. Geocoding API - for zip code fallback when Places API doesn't include zip codes
//
// Both APIs use the same API key from environment.googleMapsApiKey
// Enable both APIs in Google Cloud Console -> APIs & Services -> Library
//
import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsService {
  private loader: Loader;
  private resolvePlaces!: () => void;
  placesReady = new Promise<void>((resolve) => (this.resolvePlaces = resolve));

  constructor() {
    this.loader = new Loader({
      apiKey: environment.googleMapsApiKey, // Used for both Places API and Geocoding API
      libraries: ['places'], // Loads Places library (Geocoding is available globally)
    });
  }

  load(): Promise<void> {
    return this.loader.importLibrary('places').then(() => {
      this.resolvePlaces();
    }).catch(error => {
      throw error;
    });
  }
}
